import { PageSEO } from '@/components/SEO';

export default function Blog() {
  return (
    <div className="min-h-screen pt-32 pb-16">
      <PageSEO.blog />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-6xl font-medium mb-4">Blog</h1>
        <p className="text-lg text-stone-600">Coming soon</p>
      </div>
    </div>
  );
}
